import { useState } from 'react';
import type { Education } from '@/features/educations/types/education.types';

export interface EducationDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
  mode: 'create' | 'edit';
  education: Education | null;
  openCreate: () => void;
  openEdit: (education: Education) => void;
}

export function useEducationDialog(): EducationDialogState {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'create' | 'edit'>('create');
  const [education, setEducation] = useState<Education | null>(null);

  const openCreate = (): void => {
    setMode('create');
    setEducation(null);
    setOpen(true);
  };
  const openEdit = (next: Education): void => {
    setMode('edit');
    setEducation(next);
    setOpen(true);
  };

  return { open, setOpen, mode, education, openCreate, openEdit };
}
